import axios from "../axios";

class ContainerService {

    saveContainer(request) {
        return axios.post("api/container", request);
    }

    getAllContainerStatus() {
        return axios.get("api/container/status");
    }

    fetchContainerDetails(request) {
        return axios.post("api/container/updates", request);
    }

    getConatinerList() {
        return axios.get("api/container");
    }

    getContainerListBySupplier() {
        return axios.get("api/container/summarybysupplier");
    }

    TrackContainer() {
        return axios.get("api/container/track", { timeout: 120000 });
    }

    getInitialDates(request) {
        return axios.post("/api/container/getInitialDates", request).then(res => res.data);
    }

    getArrivingPrevNextCount(request) {
        return axios.post("/api/container/getArrivingPrevNextCount", request).then(res => res.data);
    }

    getUnloadingPrevNextCount(request) {
        return axios.post("/api/container/getUnloadingPrevNextCount", request).then(res => res.data);
    }

    loadArrivingData(request) {
        return axios.post("/api/container/arriving", request).then(res => res.data);
    }

    loadUnloadingData(request) {
        return axios.post("/api/container/unloading", request).then(res => res.data);
    }

    loadEmptiedData(request) {
        return axios.post("/api/container/emptied", request).then(res => res.data);
    }

    exportToExcel(request) {
        return axios.post("/api/container/list/export", request, {
            responseType: "blob",
        });
    }

    updateDashboardContainer(containerID, oldSection, newSection, newETA, deliveryMethod, deliveryDate, warehouseDetail) {
        return axios.post("api/container/update/dashboard-container", {
            containerID,
            oldSection,
            newSection,
            newETA,
            deliveryMethod,
            deliveryDate,
            warehouseDetail,
        }).then(res => res.data);
    }

    getContainerDetails(containerID) {
        return axios.get("/api/container/details?containerID=" + containerID);
    }

    getForwarders() {
        return axios.get("api/container/forwarders");
    }

    getWarehouseUnloadTypes() {
        return axios.get("api/container/warehouseUnloadTypes");
    }

    getContainerDeliveryMethods() {
        return axios.get("api/container/containerDeliveryMethods");
    }

    searchContainer(containerNum) {
        return axios.get("api/container/search?containerNum=" + containerNum).then(res => res.data);
    }

    searchContainerWithFilters(request) {
        return axios.post("api/container/search", request).then(res => res.data);
    }

    loadCalendarViewContainersData(request) {
        return axios.post("api/container/calendarView", request).then(res => res.data);
    }

    loadMobileViewContainersData(request) {
        return axios.post("api/container/mobileView", request).then(res => res.data);
    }
}

export default new ContainerService();